import { ReactElement } from 'react';

import './stringCellFormatter.scss';

export const stringCellFormatter = (value: string): ReactElement => {
	return <span className="string-cell-formatter">{value}</span>;
};
